module.exports = __webpack_public_path__ + "img/15.c0d18eed.png";